import React, { useEffect, useRef, useState } from 'react';

// Small replacement for the `react-typing-effect` package: types out each
// string in `text` one character at a time, pauses for `eraseDelay`, erases
// it at `eraseSpeed`, then moves on to the next string (looping forever).
const TypingEffect = ({
  text,
  className,
  speed = 200,
  eraseSpeed = 200,
  eraseDelay = 5000,
  typingDelay = 2500,
  cursor = '|',
  cursorClassName,
}) => {
  const words = typeof text === 'string' ? [text] : text;
  const [displayText, setDisplayText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const indexRef = useRef(0);
  const currentTextRef = useRef('');

  useEffect(() => {
    let timeoutId;

    const type = () => {
      const word = words[indexRef.current] || '';
      if (currentTextRef.current.length < word.length) {
        currentTextRef.current = word.substring(0, currentTextRef.current.length + 1);
        setDisplayText(currentTextRef.current);
        timeoutId = setTimeout(type, speed);
      } else {
        timeoutId = setTimeout(erase, eraseDelay);
      }
    };

    const erase = () => {
      if (currentTextRef.current.length === 0) {
        indexRef.current = (indexRef.current + 1) % words.length;
        timeoutId = setTimeout(type, typingDelay);
      } else {
        currentTextRef.current = currentTextRef.current.substring(0, currentTextRef.current.length - 1);
        setDisplayText(currentTextRef.current);
        timeoutId = setTimeout(erase, eraseSpeed);
      }
    };

    timeoutId = setTimeout(type, typingDelay);

    return () => clearTimeout(timeoutId);
    // Intentionally run once on mount, like the class-based library this replaces:
    // it never reacted to prop changes after mounting either.
  }, []);

  useEffect(() => {
    const interval = setInterval(() => setShowCursor((prev) => !prev), 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <span className={className}>
      <div style={{ display: 'inline-block' }}>{displayText}</div>
      <span
        className={cursorClassName}
        style={{ display: 'inline-block', opacity: showCursor ? 1 : 0, transition: 'opacity 0.5s' }}
      >
        {cursor}
      </span>
    </span>
  );
};

export default TypingEffect;
